let accessToken: string | null = null;

export const setAccessToken = (token: string | null) => {
  accessToken = token;
};

export const getAccessToken = () => accessToken;

const tokenFromStorage = localStorage.getItem("token");
if (tokenFromStorage) {
  setAccessToken(tokenFromStorage);
}